import { convertTimestampToLuxonOrDefaultNow } from "../../utils/convertTimestampToLuxonOrDefaultNow";
export const createAudioChunk = (data) => {
    if (!assertAudioChunk(data, "save")) {
        throw new Error("AudioChunk.save failed");
    }
    return data;
};
export function assertAudioChunk(audioChunk, mode = "load") {
    if (!audioChunk || typeof audioChunk !== "object") {
        throw new Error("AudioChunk must be an object");
    }
    const a = audioChunk;
    if (!("userId" in a)) {
        throw new Error("AudioChunk must have a userId field");
    }
    return true;
}
export const createAudioChunkConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(audioChunk) {
        if (!assertAudioChunk(audioChunk, "save")) {
            throw new Error("AudioChunk.save failed");
        }
        const { id, ...audioChunkWithoutId } = audioChunk;
        const data = {
            ...audioChunkWithoutId,
            endSession: audioChunk.endSession || false,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(audioChunk.createdAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const audioChunk = {
            ...data,
            id: snapshot.id,
            index: parseInt(data.index),
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
        };
        if (!assertAudioChunk(audioChunk)) {
            throw new Error("AudioChunk.load failed");
        }
        return audioChunk;
    },
});
//# sourceMappingURL=AudioChunk.js.map